// extracted by mini-css-extract-plugin
export default {"container":"Counter__container--fs++t"};